import script from "./PasswordResetView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetView.vue?vue&type=style&index=0&id=37c16846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c16846"]])

export default __exports__